import $ from "jquery";

export const langHandlers = () => {
    $('.lang-url').on('click', function () {
        if ($(this).data('url') !== undefined) {
            window.location.href = $(this).data('url');
        }
    });
};
